import { f as r } from "./function-uncurry-this.js";
import { r as t } from "./require-object-coercible.js";
import { t as o } from "./to-string.js";
var e = /"/g,
  c = r("".replace),
  i = function i(r, _i, s, a) {
    var m = o(t(r)),
      n = "<" + _i;
    return "" !== s && (n += " " + s + '="' + c(o(a), e, "&quot;") + '"'), n + ">" + m + "</" + _i + ">";
  };
export { i as c };